module.exports = __webpack_public_path__ + "static/media/logo_wemaza.8c53aa22.png";